<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.93699 4C9.71497 3.13739 8.93192 2.5 8 2.5C7.06808 2.5 6.28503 3.13739 6.06301 4H9.93699ZM3 4H4.53544C4.77806 2.30385 6.23676 1 8 1C9.76324 1 11.2219 2.30385 11.4646 4H13H13.25C13.6642 4 14 4.33579 14 4.75C14 5.16421 13.6642 5.5 13.25 5.5H12.8636L12.3621 11.0164V11.0164C12.2549 12.1956 12.2013 12.7852 11.9858 13.2537C11.6473 13.9896 11.0257 14.5573 10.2621 14.8278C9.77604 15 9.18403 15 8 15C6.81597 15 6.22396 15 5.73787 14.8278C4.97435 14.5573 4.35265 13.9896 4.01415 13.2537C3.79865 12.7852 3.74505 12.1956 3.63786 11.0164L3.13636 5.5H2.75C2.33579 5.5 2 5.16421 2 4.75C2 4.33579 2.33579 4 2.75 4H3ZM6.25 7C6.66421 7 7 7.33579 7 7.75V11.25C7 11.6642 6.66421 12 6.25 12C5.83579 12 5.5 11.6642 5.5 11.25V7.75C5.5 7.33579 5.83579 7 6.25 7ZM9.75 7C10.1642 7 10.5 7.33579 10.5 7.75V11.25C10.5 11.6642 10.1642 12 9.75 12C9.33579 12 9 11.6642 9 11.25V7.75C9 7.33579 9.33579 7 9.75 7Z"
    fill="currentColor"
  />
</svg>
